export const formatNumber = (value, minimumFractionDigits = 0) => {
  const number = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(number)) return "0.00";
  return number.toLocaleString(undefined, {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: 2,
  });
};

export const limitReward = () => {
  return {
    thai: [1000000, 10000, 10000, 1000, 1000, 1000, 1000, 100, 100, 10, 10],
    hanoi: [1000, 1000, 100, 100, 10, 10],
    lao: [1000, 1000, 100, 100, 10, 10],
    yeekee5: [1000, 1000, 100, 100, 10, 10],
    yeekee10: [1000, 1000, 100, 100, 10, 10],
    yeekee15: [1000, 1000, 100, 100, 10, 10],
  };
};
